// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Skehg","content":"styles_content__3Qn8u","row":"styles_row___QW0X","footer":"styles_footer__2i0MR","phraseLength":"styles_phraseLength__2gDjz"};